module.exports = __webpack_public_path__ + "static/media/avatar.07bb4a84.jpg";